export default __webpack_public_path__ + "static/media/Message_perspective_matte_s.268aa798.png";